import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 30, className = "" }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.15 }}
        transition={{ duration: 0.7, delay, ease: EASE }}
    >
        {children}
    </motion.div>
);

export const MaskedLines = ({ lines, className = "", lineClassName = "", delay = 0.15, stagger = 0.16 }) => (
    <span className={className}>
        {lines.map((line, i) => (
            <span key={i} className="mask-line">
                <motion.span
                    className={lineClassName}
                    initial={{ y: "112%" }}
                    animate={{ y: 0 }}
                    transition={{ duration: 0.95, delay: delay + i * stagger, ease: EASE }}
                >
                    {line}
                </motion.span>
            </span>
        ))}
    </span>
);
